export default __webpack_public_path__ + "0b581fe.png";